import Modal from './ActivityModal'
import PreviewModal from './ActivityPreviewModal'

export default {
    Modal,
    PreviewModal
}